import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddItems from "../AddItems";

const AddItemsDialog = ({ open, onClose, refresh }) => {
  const handleRefresh = () => {
    if (refresh) refresh();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddItems refresh={handleRefresh} />
      </Box>
    </Dialog>
  );
};

export default AddItemsDialog;
